import { createListenerMiddleware, isAnyOf, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { showSnackBar, startLoading, stopLoading } from 'src/api/ui-slice';

const apiStatusListener = createListenerMiddleware();

const IGNORED_API = "getProjectNotifications";

// The room recognition flow shows its own progress dialog with per-step results, so
// its tectly calls should drive neither the generic error snackbar nor the AppHeader
// loading bar (the 2s status poll would otherwise make it blink throughout the flow).
const RECOGNITION_ENDPOINTS = [
    'uploadTectlyFloor',
    'getTectlyFloorStatus',
    'getAndProcessTectlyResults',
    'deleteTectlyFloor',
];

const TYPEAHEAD_ENDPOINTS = ['searchParticipantLists'];

const isLoadingBarIgnored = (endpointName: string) =>
    endpointName === IGNORED_API
    || RECOGNITION_ENDPOINTS.includes(endpointName)
    || TYPEAHEAD_ENDPOINTS.includes(endpointName);

apiStatusListener.startListening({
    matcher: isPending,
    effect: (action: any, listenerApi: any) => {
        if (!isLoadingBarIgnored(action.meta.arg.endpointName)) {
          listenerApi.dispatch(startLoading('simple'));
        }

    },
});

apiStatusListener.startListening({
    matcher: isAnyOf(isFulfilled, isRejected),
    effect: (action: any, listenerApi: any) => {
        if (action.error?.name !== 'ConditionError' && !isLoadingBarIgnored(action.meta.arg.endpointName)) {
          listenerApi.dispatch(stopLoading());
        }
    },
});

apiStatusListener.startListening({
  matcher: isRejected,
  effect: (action: any, listenerApi: any) => {
    if (RECOGNITION_ENDPOINTS.includes(action.meta?.arg?.endpointName)) {
      return;
    }
    // ApiResponse with success false
    if (action.error?.name !== 'ConditionError' &&
        action?.payload?.data?.success != null && action?.payload?.data?.success === false
        && action?.payload?.data?.errorMessage != null) {
      listenerApi.dispatch(showSnackBar({ text: action?.payload?.data?.errorMessage, severity: 'error'}))
    }
  },
});

export default apiStatusListener.middleware;